@if (config().building) {
  <mat-form-field
    class="stroked-select-single"
    appearance="outline"
  >
    <mat-select-trigger>Building</mat-select-trigger>
    <mat-select
      (valueChange)="filtersChanged.emit({
          building: $event,
          floor: '',
          room: '',
        })"
      [value]="filters()?.building"
      panelClass="single-select-overlay test-building-selector"
    >
      @for (building of config().options.building| sort : 'asc' : 'title' : 'all'; track building.value) {
        <mat-option [value]="building.value">
          {{ building.title }}
        </mat-option>
      }
    </mat-select>
    <mat-icon
      class="arrow-down"
      matSuffix
    > keyboard_arrow_down
    </mat-icon>
  </mat-form-field>
}

@if (filters()?.building && config().floor) {
  <mat-form-field
    class="stroked-select-single"
    appearance="outline"
  >
    <mat-select-trigger>Floor</mat-select-trigger>
    <mat-select
      (valueChange)="filtersChanged.emit({
          floor: $event,
          room: undefined,
        })"
      [value]="filters()?.floor"
      panelClass="single-select-overlay test-floor-selector"
    >
      @for (floor of config().options.floor| sort : 'asc' : 'title' : 'all'; track floor.value) {
        <mat-option [value]="floor.value">
          {{ floor.title }}
        </mat-option>
      }
    </mat-select>
    <mat-icon
      class="arrow-down"
      matSuffix
    > keyboard_arrow_down
    </mat-icon>

  </mat-form-field>
}

@if (filters()?.floor) {
  <mat-form-field
    class="stroked-select-single"
    appearance="outline"
  >
    <mat-select-trigger>Room</mat-select-trigger>
    <mat-select
      (valueChange)="filtersChanged.emit({ room: $event })"
      [value]="filters()?.room"
      panelClass="single-select-overlay device-room-filter-overlay test-room-selector"
    >
      @for (room of config().options.room | sort : 'asc' : 'title' : 'all'; track room.value) {
        <mat-option [value]="room.value">
          {{ room.title }}
        </mat-option>
      }
    </mat-select>
    <mat-icon
      class="arrow-down"
      matSuffix
    > keyboard_arrow_down
    </mat-icon>
  </mat-form-field>
}
